var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentAnnotation === _vm.id)?_c('div',{staticClass:"annotation position-absolute",attrs:{"id":_vm.id}},[_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('h1',[_vm._v("Model Predictive Control")]),_vm._t("default")],2)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }